<footer>
  &copy; {{copyrightYear}} Alight Solutions. All rights reserved.
  <a href="https://cache.alight.com/privacy/PrivStat.htm" target="_blank">Privacy Policy</a> | 
  <a href="https://cache.alight.com/privacy/AHCookies.htm" target="_blank">Cookie Notice</a> |
  <a href="https://alight.com/legal-terms" target="_blank">Terms Of Use</a>
</footer>

